import { Typography } from '@mui/material';

const FormTitle = ({label}) => (
  <Typography variant="h6" sx={{ mt: 2 }}>
    {label}
  </Typography>
);

export default FormTitle;